/**
 * Public GitHub avatar URL for a VantagePoint session user (`githubId` / `githubUsername` from auth).
 */
export function userGithubAvatarUrl(user) {
  if (!user) return null;
  const id = user.githubId;
  if (id != null && Number.isFinite(Number(id))) {
    return `https://avatars.githubusercontent.com/u/${Number(id)}?v=4`;
  }
  const login = (user.githubUsername || '').trim();
  if (login) return `https://github.com/${encodeURIComponent(login)}.png`;
  return null;
}

/**
 * Avatar for an org member row: first linked GitHub contributor (org), else account-linked GitHub on User.
 * @param {Record<string, unknown>|null|undefined} member
 * @returns {string|null}
 */
export function orgMemberAvatarUrl(member) {
  if (!member) return null;
  const links = Array.isArray(member.linkedContributors) ? member.linkedContributors : [];
  const first = links[0];
  if (first) {
    const lid = first.githubId;
    if (lid != null && Number.isFinite(Number(lid))) {
      return `https://avatars.githubusercontent.com/u/${Number(lid)}?v=4`;
    }
    const llogin = (first.githubUsername || '').trim();
    if (llogin) return `https://github.com/${encodeURIComponent(llogin)}.png`;
  }
  return userGithubAvatarUrl(member);
}

/**
 * Avatar for contributor analytics / bar chart rows (stored Contributor or commit-derived shape).
 * @param {Record<string, unknown>|null|undefined} row
 * @returns {string|null}
 */
export function contributorRowAvatarUrl(row) {
  if (!row) return null;
  const direct = String(row.avatarUrl || '').trim();
  if (direct) return direct;
  const id = row.githubId;
  if (id != null && Number.isFinite(Number(id))) {
    return `https://avatars.githubusercontent.com/u/${Number(id)}?v=4`;
  }
  const login = String(
    row.github || row.githubUsername || row.authorGithub || row.actor || row.author || ''
  ).trim();
  if (login) return `https://github.com/${encodeURIComponent(login)}.png`;
  return null;
}
